import itemId from 'owa-service/lib/factory/itemId';
import { action } from 'satcheljs/lib/legacy';
function setRecipientWellNotDirty(wellViewState) {
    if (wellViewState) {
        wellViewState.isDirty = false;
    }
}
export default action('updateComposeItemId')(function updateComposeItemId(viewState, id, changeKey, lastModifiedTime) {
    if (viewState) {
        if (viewState.itemId) {
            // Id doesn't change, we only need to update the ChangeKey
            viewState.itemId.ChangeKey = changeKey;
        }
        else {
            viewState.itemId = itemId({
                Id: id,
                ChangeKey: changeKey,
            });
        }
        if (lastModifiedTime) {
            viewState.lastSaveTimeStamp = lastModifiedTime;
            viewState.isDirty = false;
            setRecipientWellNotDirty(viewState.toRecipientWell);
            setRecipientWellNotDirty(viewState.ccRecipientWell);
            setRecipientWellNotDirty(viewState.bccRecipientWell);
        }
    }
});
//# sourceMappingURL=updateComposeItemId.js.map